module.exports = __webpack_public_path__ + "media/images/pages/pocstock-hero-mobile-aa93559421095918463b5910634ed891.png";